// extracted by mini-css-extract-plugin
module.exports = {"navSlider":"_17sMcuL","mainSlider":"_1HN902C","navArrows":"_2VeXSkc"};